// MessageDefinitions.js
module.exports = {
  commercant: {
    sideInfo: {
      trad: {
        background: '/static/images/collection-newspapers.jpg',
        size: 220,
        left: 0,
        top: -1000,
        gradient: {
          color: '#880E4F'
        }
      },
      boulangerie: {
        background: '/static/images/bakery-bread_lumiere40.jpg',
        size: 200,
        left: 0,
        top: -900,
        gradient: {
          color: '#880E4F'
        }
      },
      fleuriste: {
        background: '/static/images/spring-flowers-1613759017_lumiere40.jpg',
        size: 150,
        left: -200,
        top: -500,
        gradient: {
          color: '#880E4F'
        }
      }
    },
    templates: [
      {
        id: 0,
        name: 'default',
        label: 'Visualisation',
        previewPath: '/static/images/template-annonces/visualisation-default.png',
        reducedStyle: {
          title: {},
          mainText: {}
        },
        fullStyle: {
          title: {},
          mainText: {},
          backgroundStyle: {
            backgroundImage: {
              trad: 'url(/static/images/template-annonces/visualisation-default.png)',
              boulangerie: 'url(/static/images/template-annonces/visualisation-default.png)',
              fleuriste: 'url(/static/images/template-annonces/visualisation-default.png)'
            },
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%'
          }
        }
      },
      {
        id: 1,
        templateId: 20,
        name: 'texte-seul',
        label: 'Texte Seul',
        thumbnails: {
          trad: '/static/images/template-annonces/texte-seul-presse-vignette.png',
          boulangerie: '/static/images/template-annonces/texte-seul-boulangerie-vignette.png',
          fleuriste: '/static/images/template-annonces/texte-seul-fleuriste-vignette.png'
        },
        reducedStyle: {
          titleStyle: {
            letterSpacing: '1px',
            fontSize: '35px',
            color: {
              trad: '#a81a18',
              boulangerie: '#c46a1c',
              fleuriste: '#20ad83',
            },
            width: '450px',
            height: '45px',
            top: '9px',
            left: 'calc((512px - 450px) / 2)'
          },
          title: {
            defaultHtml: 'Votre Titre',
            lengthLimit: 20,
            shouldCheck: true
          },
          mainTextStyle: {
            letterSpacing: '1px',
            fontSize: '18px',
            color: '#fff',
            width: '240px',
            height: '165px',
            top: '97px',
            left: 'calc(((512px - 240px) / 2) - 15px)'
          },
          mainText: {
            defaultHtml: '<p placeholder="Votre texte"></p>',
            lengthLimit: 400,
            shouldCheck: true
          },
          imageInput: {
            shouldCheck: false
          }
        },
        fullStyle: {
          backgroundStyle: {
            backgroundImage: {
              trad: 'url(/static/images/template-annonces/texte-seul-full-presse.png)',
              boulangerie: 'url(/static/images/template-annonces/texte-seul-full-boulangerie.png)',
              fleuriste: 'url(/static/images/template-annonces/texte-seul-full-fleuriste.png)'
            },
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%'
          },
          titleStyle: {
            letterSpacing: '2px',
            fontSize: '70px',
            color: {
              trad: '#a81a18',
              boulangerie: '#c46a1c',
              fleuriste: '#20ad83',
            },
            position: 'absolute',
            color: {
              trad: '#a81a18',
              boulangerie: '#c46a1c',
              fleuriste: '#20ad83',
            },
            width: '900px',
            height: '91px',
            top: '17px',
            left: 'calc((1024px - 900px) / 2)'
          },
          title: {
            html: ''
          },
          mainTextStyle: {
            letterSpacing: '2px',
            fontSize: '36px',
            color: '#fff',
            width: '480px',
            height: '350px',
            top: '194px',
            left: 'calc(((1024px - 480px) / 2) - 29px)'
          },
          mainText: {
            html: ''
          },
          imageInputStyle: {
            position: 'absolute',
            width: '1024px',
            height: '668px',
            top: '10000px',
            left: '0',
            border: 'none'
          },
          imageInputPlaceholderHTML: null,
          imageInput: {
            shouldCheck: false
          }
        }
      },
      {
        id: 2,
        templateId: 21,
        name: 'texte-image-1',
        label: 'Texte et image 1',
        thumbnails: {
          trad: '/static/images/template-annonces/texte_image_1-vignette-presse.png',
          boulangerie: '/static/images/template-annonces/texte_image_1-vignette-boulangerie.png',
          fleuriste: '/static/images/template-annonces/texte_image_1-vignette-fleuriste.png'
        },
        reducedStyle: {
          titleStyle: {
            letterSpacing: '1px',
            fontSize: '35px',
            color: '#fff',
            width: '450px',
            height: '45px',
            top: '9px',
            left: 'calc((512px - 450px) / 2)'
          },
          title: {
            defaultHtml: 'Votre Titre',
            lengthLimit: 20,
            shouldCheck: true
          },
          mainTextStyle: {
            letterSpacing: '1px',
            fontSize: '18px',
            color: {
              trad: '#a81a18',
              boulangerie: '#c46a1c',
              fleuriste: '#20ad83',
            },
            width: '200px',
            height: '167px',
            top: '105px',
            left: '20px'
          },
          mainText: {
            defaultHtml: '<p placeholder="Votre texte"></p>',
            lengthLimit: 125,
            shouldCheck: true
          },
          imageInputStyle: {
            position: 'absolute',
            width: '212px',
            height: '212px',
            top: '76px',
            left: '275px',
            border: 'none',
            backgroundColor: '#fff'
          },
          imageInput: {
            shouldCheck: true,
            hoverBorderStyles: {
              border: '5px dashed #cd0975'
            }
          },
          imageInputPlaceholderStyle: {
            textAlign: 'center',
            fontFamily: 'DINProBold, Arial, sans-serif',
            fontSize: '12px',
            letterSpacing: '2px',
            display: 'block',
            cursor: 'pointer',
            color: {
              trad: '#a81a18',
              boulangerie: '#c46a1c',
              fleuriste: '#20ad83',
            },
            height: '212px',
            paddingTop: '50px',
            border: 'none'
          },
          imageInputPlaceholderHTML: 'Déposer<br/>votre image ici<br/>ou cliquer'
        },
        fullStyle: {
          backgroundStyle: {
            backgroundImage: {
              trad: 'url(/static/images/template-annonces/texte_image_1-full_presse.png)',
              boulangerie: 'url(/static/images/template-annonces/texte_image_1-full_boulangerie.png)',
              fleuriste: 'url(/static/images/template-annonces/texte_image_1-full_fleuriste.png)'
            },
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%'
          },
          titleStyle: {
            letterSpacing: '2px',
            fontSize: '70px',
            position: 'absolute',
            color: '#fff',
            width: '900px',
            height: '91px',
            top: '17px',
            left: 'calc((1024px - 900px) / 2)'
          },
          title: {
            html: ''
          },
          mainTextStyle: {
            letterSpacing: '2px',
            fontSize: '36px',
            color: {
              trad: '#a81a18',
              boulangerie: '#c46a1c',
              fleuriste: '#20ad83',
            },
            width: '400px',
            height: '325px',
            top: '210px',
            left: '40px'
          },
          mainText: {
            html: ''
          },
          imageInputStyle: {
            position: 'absolute',
            width: '425px',
            height: '425px',
            top: '153px',
            left: '551px',
            border: 'none',
            backgroundColor: '#fff'
          },
          imageInput: {}
        }
      },
      {
        id: 3,
        templateId: 22,
        name: 'texte-image-2',
        label: 'Texte et image 2',
        thumbnails: {
          trad: '/static/images/template-annonces/texte_image_2.png',
          boulangerie: '/static/images/template-annonces/texte_image_2.png',
          fleuriste: '/static/images/template-annonces/texte_image_2.png'
        },
        reducedStyle: {
          title: {
            shouldCheck: false
          },
          mainTextStyle: {
            letterSpacing: '1px',
            color: '#000',
            width: '450px',
            height: '60px',
            top: '267px',
            left: 'calc((512px - 450px) / 2)'
          },
          mainText: {
            defaultHtml: '<p placeholder="Votre texte"></p>',
            lengthLimit: 150,
            shouldCheck: true
          },
          imageInputStyle: {
            width: '512px',
            height: '334px',
            top: '0',
            left: '0',
            border: 'none'
          },
          imageInputPlaceholderStyle: {
            textAlign: 'center',
            fontFamily: 'DINProBold, Arial, sans-serif',
            fontSize: '12px',
            letterSpacing: '2px',
            display: 'block',
            cursor: 'pointer',
            color: '#fff',
            height: '334px',
            paddingTop: '175px',
            border: 'none'
          },
          imageInputPlaceholderHTML: 'Déposer<br/>votre image ici<br/>ou cliquer',
          imageInput: {
            shouldCheck: true,
            hoverBorderStyles: {
              border: '5px dashed #cd0975'
            }
          },
          whiteMaskStyle: {
            width: '512px',
            height: '84px',
            top: '250px',
            left: '0'
          }
        },
        fullStyle: {
          backgroundStyle: {
            backgroundImage: {
              trad: 'url(/static/images/template-annonces/image-seule.png)',
              boulangerie: 'url(/static/images/template-annonces/image-seule.png)',
              fleuriste: 'url(/static/images/template-annonces/image-seule.png)'
            },
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%'
          },
          titleStyle: {
            top: '10000px'
          },
          mainTextStyle: {
            letterSpacing: '2px',
            fontSize: '36px',
            color: '#000',
            width: '900px',
            height: '120px',
            top: '525px',
            left: 'calc((1024px - 900px) / 2)'
          },
          mainText: {
            html: ''
          },
          imageInputStyle: {
            width: '1024px',
            height: '668px',
            top: '0',
            left: '0',
            border: 'none'
          },
          imageInput: {},
          whiteMaskStyle: {
            width: '1024px',
            height: '168px',
            top: '500px',
            left: '0'
          },
          title: {
            shouldCheck: false
          }
        }
      },
      {
        id: 4,
        templateId: 23,
        name: 'image-seule',
        label: 'Image seule',
        thumbnails: {
          trad: '/static/images/template-annonces/image-seule.png',
          boulangerie: '/static/images/template-annonces/image-seule.png',
          fleuriste: '/static/images/template-annonces/image-seule.png'
        },
        reducedStyle: {
          title: {
            shouldCheck: false
          },
          mainText: {
            shouldCheck: false
          },
          imageInputStyle: {
            width: '512px',
            height: '334px',
            top: '0',
            left: '0',
            border: 'none'
          },
          imageInputPlaceholderStyle: {
            textAlign: 'center',
            fontFamily: 'DINProBold, Arial, sans-serif',
            fontSize: '12px',
            letterSpacing: '2px',
            display: 'block',
            cursor: 'pointer',
            color: '#fff',
            height: '334px',
            paddingTop: '225px',
            border: 'none'
          },
          imageInputPlaceholderHTML: 'Déposer<br/>votre image ici<br/>ou cliquer',
          imageInput: {
            shouldCheck: true,
            hoverBorderStyles: {
              border: '5px dashed #cd0975'
            }
          }
        },
        fullStyle: {
          backgroundStyle: {
            backgroundImage: {
              trad: 'url(/static/images/template-annonces/image-seule-full.png)',
              boulangerie: 'url(/static/images/template-annonces/image-seule-full.png)',
              fleuriste: 'url(/static/images/template-annonces/image-seule-full.png)'
            },
            backgroundSize: 'cover',
            backgroundPosition: '50% 50%'
          },
          titleStyle: {
            top: '10000px'
          },
          mainTextStyle: {
            top: '10000px'
          },
          imageInputStyle: {
            width: '1024px',
            height: '668px',
            top: '0',
            left: '0',
            border: 'none'
          },
          imageInput: {},
          title: {
            shouldCheck: false
          },
          mainText: {
            shouldCheck: false
          }
        }
      }
    ]
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/annonces-app-modules/config/MessageDefinitions.js
// module id = 78
// module chunks = 0